module.exports = __webpack_public_path__ + "img/qrcode.4814f219.jpg";